import { DocumentDomain } from "~/context/Shared/domain/DocumentDomain";
import { DocumentDomainSII } from "~/context/Shared/domain/DocumentDomainSII";
import { MovementDomainFintoc } from "~/context/Shared/domain/MovementDomainFintoc";
import moment from "moment";
import levenshtein from 'fast-levenshtein';
import { referenceAsDocument } from "~/utils/functions.vue";
import { ExpenseDomain } from "~/context/Shared/domain/ExpenseDomain";


export function formatMoneyLatam(value) {  
  if (value) {
    
    if(Math.abs(value - Math.floor(value)) > 0.5){
      return Math.ceil(value).toLocaleString('es-CL');
      }

    if(Math.abs(value - Math.floor(value)) < 0.5){
      return Math.floor(value).toLocaleString('es-CL');
      }

    if (parseInt(value) == 0 || isNaN(parseInt(value) || value == '0')) {
      return 0;
    }
    return parseInt(value).toLocaleString('es-CL');
  }
  return 0;
}

export function formatMoneyWithDecimal(value) {
  if (value) {
    if (parseInt(value) == 0 || isNaN(parseInt(value) || value == '0')) {
      return 0;
    }
    return value.toLocaleString('es-CL');
  }
  return 0;
}


export function formatMoneyLatamShort(value) {
  console.log("value: ", value);
  if (value) {
    if (parseInt(value) == 0 || isNaN(parseInt(value) || value == '0')) {
      return 0;
    }
    const valueInInt = parseInt(value);
    if (valueInInt >= 1000000000) {
      const mmillions = value / 1000000000;
      return mmillions.toFixed(1) + "MM";
    } else if (valueInInt >= 1000000) {
      const millions = valueInInt / 1000000;
      return millions.toFixed(1) + "M";
    } else if (valueInInt >= 1000) {
      const miles = valueInInt / 1000;
      return miles.toFixed(1) + "K";
    } else {
      return valueInInt.toString();
    }

    return parseInt(value).toLocaleString('es-CL');
  }
  return 0;
}


export function formatMovementDescription(element) {
  if (element) {
   // console.log("formatMovementDescription element: ", JSON.stringify(element));
    const a = element.movement_sender + " " + formatRut(element.movement_sender_legal_id) + " " + element.movement_receiver + " " + formatRut(element.movement_receiver_legal_id);

    const a2 = a?.replace(/\s/g, "");
    if (a2?.length < 1) {
      return element.movement_description;
    } else {
      return a;
    }
  }
  return '-';
}

export function formatDocumentDescription(element) {
  console.log("formatDocumentDescription:" + JSON.stringify(element));
  if (element) {
    const a = element.document_enterprise_name;

    const a2 = a?.replace(/\s/g, "");
    if (a2?.length < 1) {
      return element.document_description;
    } else {
      return a;
    }
  }
  return '-';
}


export function formatReconciliationReferenceDescription(element) {
  if (element) {
    const a = element.reconciliation_reference_description;

    const a2 = a?.replace(/\s/g, "");
    if (a2?.length < 1) {
      return element.reconciliation_reference_description;
    } else {
      return a;
    }
  }
  return '-';
}



export function formatScreenMoneyLatam(value) {
  let screenSize = window.innerWidth;

  if (value) {
    if (parseInt(value) == 0 || isNaN(parseInt(value) || value == '0')) {
      return 0;
    } else {
      if (screenSize > 500) {
        return parseInt(value).toLocaleString('es-CL');
      } else {

        let dataRet = Math.round((parseInt(value) / 1000)) + "K";
        return dataRet;
      }

    }

  }
  return 0;
}


export function cleanDotsAndDash(value) {
  if (value) {
    return value.replace(/[.-]/g, '').toUpperCase();
  }
  return "";
}


export function calculateDistanceDocumentMovement(document, movement, legalId) {

  let containsLegalId = false;


  if (formatRut(legalId) === formatRut(document.document_sender_legal_id)) {
    containsLegalId = cleanDotsAndDash(movement.movement_client_provider).includes(cleanDotsAndDash(document.document_receiver_legal_id)) || cleanDotsAndDash(movement.movement_description).includes(cleanDotsAndDash(document.document_receiver_legal_id));
  } else if (formatRut(legalId) === formatRut(document.document_receiver_legal_id)) {

    containsLegalId = cleanDotsAndDash(movement.movement_client_provider).includes(cleanDotsAndDash(document.document_sender_legal_id)) || cleanDotsAndDash(movement.movement_description).includes(cleanDotsAndDash(document.document_sender_legal_id));
  }
  return containsLegalId;
}

export function calculateDistance(invoice, movement, legalId) {
  let containsLegalId = false;

  if (formatRut(legalId) === formatRut(invoice.invoice_sender_legal_id)) {
    containsLegalId = cleanDotsAndDash(movement.movement_client_provider).includes(cleanDotsAndDash(invoice.invoice_receiver_legal_id)) || cleanDotsAndDash(movement.movement_description).includes(cleanDotsAndDash(invoice.invoice_receiver_legal_id));
  } else if (formatRut(legalId) === formatRut(invoice.invoice_receiver_legal_id)) {
    containsLegalId = cleanDotsAndDash(movement.movement_client_provider).includes(cleanDotsAndDash(invoice.invoice_sender_legal_id)) || cleanDotsAndDash(movement.movement_description).includes(cleanDotsAndDash(invoice.invoice_sender_legal_id));
  }
  return containsLegalId;

};


export function validateRut(rut) {
  // Eliminar puntos, guiones y convertir a mayúsculas
  rut = rut.replace(/[^\dK]/g, '').toUpperCase();

  // Validar largo mínimo
  if (rut.length < 7) return false;

  // Extraer el cuerpo y el dígito verificador
  const body = rut.slice(0, -1);
  const bodyReverse = body.split('').reverse();
  const verifier = rut.slice(-1);

  // Calcular el dígito verificador
  let sum = 0;

  const factors = [2, 3, 4, 5, 6, 7];
  for (let i = 0; i < bodyReverse.length; i++) {
    sum += parseInt(bodyReverse[i]) * factors[i % factors.length];
  }

  const calculatedVerifier = 11 - (sum % 11);
  const calculatedVerifierChar = calculatedVerifier === 11 ? '0' : calculatedVerifier === 10 ? 'K' : calculatedVerifier.toString();
  // Comparar el dígito verificador calculado con el dígito verificador del RUT
  return verifier === calculatedVerifierChar;
}


export function formatRut(value) {
  //console.log("formatRut value:" + JSON.stringify(value));
  let formattedRut = "";
  if (value) {
    // Eliminar puntos y guiones del RUT y convertir a mayúsculas        
    let rut = value.replace(/\./g, '').replace(/-/g, '').toUpperCase();
    // Separar el RUT en número y dígito verificador
    const rutNumber = rut.slice(0, -1);
    const verificador = rut.slice(-1);
    // Agregar puntos al número del RUT
    formattedRut = rutNumber.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");

    // Agregar guión y dígito verificador
    formattedRut = formattedRut + "-" + verificador;
  }
  return formattedRut;
}


  export function normalizarRut(rut) {
    return rut?.replace(/\./g, '')?.replace(/-/g, '');
  }

  export function normalizarRutConGuion(rut){
    if (rut?.length <= 2) return rut;
    rut = normalizarRut(rut);
    console.log("normalizarRutConGuion:" + rut);
    return rut.slice(0, -1) + '-' + rut.slice(-1);

  }

export function formatEnterpriseSuffix(text) {

  const regex = /(.*?)(\s+)?(spa|limitada|ltda|sa|s\.?a\.?\.?|s\.?a\.?)$/i;

  // Reemplazar el sufijo empresarial con una cadena vacía
  if (text) {
    return text.replace(regex, '$1').trim();
  } else {
    return "";
  }
}

export function reconciliationReferenceType(recReference, company) {
  console.log("\n(reconciliationReferenceType) recReference:"+ JSON.stringify(recReference));
  let objectType = recReference.reconciliation_reference_type;
  let objectOriginType = recReference.reconciliation_reference_object_original_type;
  if (objectType === DocumentDomain.MOVEMENT) {

    return formatMovementType(objectType, objectOriginType, recReference.reconciliation_reference_amount)
  } else {
    const document = referenceAsDocument(recReference)

    return formatDocumentFullType(document, company)
  }
}

export function isDocumentIncome(document, company) {
  if (document.document_type === DocumentDomain.INVOICE && formatRut(document.document_receiver_legal_id) === formatRut(company.company_legal_id)) {
    return false;
  } else if (document.document_type === DocumentDomain.INVOICE && formatRut(document.document_sender_legal_id) === formatRut(company.company_legal_id)) {
    return true;

  } else if (document.document_type === DocumentDomain.BILL && formatRut(document.document_sender_legal_id) === formatRut(company.company_legal_id)) {
    return true;
  }
  else {
    return false;
  }
}

export function formatSimpleMovementType(movementType, movementOriginalType, movementAmount) {
let formatMovementType = "";
//console.log("formatSimpleMovementType movementType:" + movementType);
//console.log("formatSimpleMovementType movementOriginalType:" + movementOriginalType);
//console.log("formatSimpleMovementType movementAmount:" + movementAmount);
 if (movementType) {
    switch (movementType) {
      case DocumentDomain.MOVEMENT:
        if (movementAmount > 0) {
          formatMovementType = "Abono";
        } else {
          formatMovementType = "Cargo";
        }
        break;
      default:
        formatMovementType = movementType;
    }
  }
  return formatMovementType;
}

export function formatMovementType(movementType, movementOriginalType, movementAmount) {
  let formatMovementType = "";

  if (movementType) {
    switch (movementType) {
      case DocumentDomain.MOVEMENT:
        if (movementAmount > 0) {
          formatMovementType = "Abono";
        } else {
          formatMovementType = "Egreso";
        }
        break;
      default:
        formatMovementType = movementType;
    }
  }
  if (movementOriginalType) {
    switch (movementOriginalType) {
      case MovementDomainFintoc.TRANSFER:
        formatMovementType += " Transferencia";
        break;
      case MovementDomainFintoc.CHECK:
        formatMovementType += " Cheque";
        break;
      case MovementDomainFintoc.OTHER:
        formatMovementType += " Otro";
        break;
      default:
        formatMovementType = movementOriginalType;
    }
  }
  return formatMovementType;
}

export function formatData(data) {
  if (data !== null || data !== undefined || data !== "undefined" || data !== "") {
    return data;
  }
  return "-";
}

export function formatReconciliationType(reference, company) {

  let documentType = reference.reconciliation_reference_type;
  let documentOriginType = reference.reconciliation_reference_object_original_type;
  let documentState = reference.reconciliation_reference_state;
  let formatDocument = formatDocumentType(documentType, documentOriginType, documentState);


  if (documentType === DocumentDomain.INVOICE && formatRut(reference.document_receiver_legal_id) === formatRut(company.company_legal_id)) {
    return formatDocument + " Proveedor";
  } else if (documentType === DocumentDomain.INVOICE && formatRut(reference.document_sender_legal_id) === formatRut(company.company_legal_id)) {
    return formatDocument + " Venta";
  } else {
    return formatDocument;
  }


}

export function isNC(document, company) {

  if (document.document_original_type === DocumentDomainSII.NOTACREDITOFISICA || document.document_original_type === DocumentDomainSII.NOTACREDITOELECTRONICA) {

    if (document.document_type === DocumentDomain.INVOICE && formatRut(document.document_sender_legal_id) === formatRut(company.company_legal_id)) {
      return true;
    }

  } else {
    return false;
  }

}

export function formatType(type){
  switch (type) {
    case DocumentDomain.INVOICE:
      return "Factura";
    case DocumentDomain.EXPENSE:
      return "Gasto";
    case DocumentDomain.MOVEMENT:
      return "Movimiento";
    case DocumentDomain.BILL:
      return "Boleta";
    default:
      return type;
  }
}

export function formatDocumentFullType(document, company) {
  let documentType = document.document_type;
  let documentOriginType = document.document_original_type;
  let documentState = document.document_state;
  let formatDocument = formatDocumentType(documentType, documentOriginType, documentState);

  if (documentType === DocumentDomain.INVOICE && formatRut(document.document_receiver_legal_id) === formatRut(company.company_legal_id)) {
    return formatDocument + " Proveedor";
  } else if (documentType === DocumentDomain.INVOICE && formatRut(document.document_sender_legal_id) === formatRut(company.company_legal_id)) {
    return formatDocument + " Venta";
  } else {
    return formatDocument;
  }
}


export function formatDocumentEmployee(document, company) {
  let documentType = document.document_type;
  let documentOriginType = document.document_original_type;
  let documentState = document.document_state;
let formatDocumentType = "";
  console.log("formatDocumentEmployee (documentType):" +  documentType);
  console.log("formatDocumentEmployee (documentOriginType):" +  documentOriginType);
  if (documentType) {
    switch (documentType) {
      case DocumentDomain.EXPENSE:
        switch (documentOriginType) {
        case ExpenseDomain.SALARYFRONT:
          formatDocumentType = "Remuneracion";
          break;
        case ExpenseDomain.ADVANCE:
          formatDocumentType = "Adelanto";
          break;
        } 
  }
}
  return formatDocumentType;
}

export function formatDocumentSimpleType(document, company) {
  let documentType = document.document_type;
  let documentOriginType = document.document_original_type;
  let documentState = document.document_state;
  let formatDocumentType = "";
  //let formatDocument = formatDocumentType(documentType, documentOriginType, documentState);
  if (documentType) {
    switch (documentType) {
      case DocumentDomain.INVOICE:
        switch (documentOriginType) {
          case DocumentDomainSII.FACTURAFISICA:
            formatDocumentType = "Factura";
            break;
          case DocumentDomainSII.FACTURAELECTRONICA:
            formatDocumentType = "Factura";
            break;
          case DocumentDomainSII.NOTACREDITOFISICA:
            formatDocumentType = "Nota de Crédito";
            break;
          case DocumentDomainSII.NOTACREDITOELECTRONICA:
            formatDocumentType = "Nota de Crédito";
            break;
          case DocumentDomainSII.FACTURADECOMPRAELECTRONICA:
            formatDocumentType = "Factura de Compra";
            break;
          case DocumentDomainSII.NOTADEDEBITOFISICA:
            formatDocumentType = "Nota de Débito";
            break;
          case DocumentDomainSII.NOTADEBITOELECTRONICA:
            formatDocumentType = "Nota de Débito";
            break;
          case DocumentDomainSII.FACTURAELECTRONICAVENTA:
            formatDocumentType = "Factura Exenta";
            break;        
          }
        break;
      case DocumentDomain.EXPENSE:
        if (documentOriginType === 'incomespot') {
          formatDocumentType = "Ingreso";
          break;

        } else {
          formatDocumentType = "Gasto";
          break;

        }
      case DocumentDomain.BILL:
        formatDocumentType = "Boleta";
        break;
      case DocumentDomain.MOVEMENT:
        formatDocumentType = "Movimiento";
        break;
      default:
        formatDocumentType = documentType;
    }
  }
  return formatDocumentType;
}


export function formatDocumentType(documentType, documentOriginType, documentState) {
  let formatDocumentType = "";
  if (documentType) {
    switch (documentType) {
      case DocumentDomain.INVOICE:
        formatDocumentType = "Factura";
        break;
      case DocumentDomain.EXPENSE:
        if (ExpenseDomain.INFLOWS.includes(documentOriginType)){                
          formatDocumentType = "Ingreso";
          break;
        } else {
          formatDocumentType = "Gasto";
          break;

        }
      case DocumentDomain.BILL:
        formatDocumentType = "Boleta";
        break;
      case DocumentDomain.MOVEMENT:
        formatDocumentType = "Movimiento";
        break;
      default:
        formatDocumentType = documentType;
    }
  }
  if (documentType && documentType === DocumentDomain.INVOICE && documentOriginType) {
    switch (documentOriginType) {
      case DocumentDomainSII.FACTURAFISICA:
        formatDocumentType = "Factura";
        break;
      case DocumentDomainSII.FACTURAELECTRONICA:
        formatDocumentType = "Factura";
        break;
      case DocumentDomainSII.NOTACREDITOFISICA:
        formatDocumentType = "Nota de Crédito";
        break;
      case DocumentDomainSII.NOTACREDITOELECTRONICA:
        formatDocumentType = "Nota de Crédito";
        break;
      case DocumentDomainSII.FACTURADECOMPRAELECTRONICA:
        formatDocumentType = "Factura de Compra";
        break;
      case DocumentDomainSII.NOTADEDEBITOFISICA:
        formatDocumentType = "Nota de Débito";
        break;
      case DocumentDomainSII.NOTADEBITOELECTRONICA:
        formatDocumentType = "Nota de Débito";
        break;
      case DocumentDomainSII.FACTURAELECTRONICAVENTA:
        formatDocumentType = "Factura Exenta";
        break;
      case DocumentDomainSII.FACTURAEXPORTACION:
        formatDocumentType = "Factura Exportación";
        break;
      case DocumentDomainSII.NOTACREDITOEXPORTACION:
        formatDocumentType = "Nota de Crédito Exportación";
        break;

      default:
        formatDocumentType = documentType;
    }
    if (documentType && documentType === DocumentDomain.INVOICE && documentState) {
      switch (documentState) {
        case DocumentDomainSII.EMITIDO:
          //formatDocumentType = formatDocumentType + " Emitida";
          formatDocumentType = formatDocumentType 
          break;
        case DocumentDomainSII.RECHAZADO:
          formatDocumentType = formatDocumentType + " Rechazada";
          break;
        case DocumentDomainSII.RECLAMADO:
          formatDocumentType = formatDocumentType + " Reclamada";
          break;
        case DocumentDomainSII.REGISTRO:
          formatDocumentType = formatDocumentType 
          //formatDocumentType = formatDocumentType + " Registrada";
          break;

      }
    }
  }
  if (documentType && documentType === DocumentDomain.BILL && documentOriginType) {


    switch (documentOriginType) {
      case "siibillbh":
        formatDocumentType = formatDocumentType + " Honorarios";
        break;

    }
  }

  if (documentType && documentType === DocumentDomain.EXPENSE && documentOriginType) {


    switch (documentOriginType) {
      case "siitaxf22":
        formatDocumentType = formatDocumentType + " SII RENTA";
        break;
      case "siitaxf29":
        formatDocumentType = formatDocumentType + " SII IVA";
        break;
      case "wage":
        formatDocumentType = formatDocumentType + " Honorarios";
        break;
      case "salary":
        formatDocumentType = " Remuneración";
        break;
      case "incomespot":
        formatDocumentType = formatDocumentType + " Registrado";
        break;
      case "mutualfund":
        formatDocumentType = " Fondo Mutuo";
        break;
      case "previred":
        formatDocumentType = " Previred";
        break;
      case "assetsale":
        formatDocumentType = " Venta Activo";
        break;
      case "compensation":
        formatDocumentType = formatDocumentType + " Compensación";
        break;
      case "subsidies":
        formatDocumentType = " Subsidio";
        break;
      case "capitalinjection":
        formatDocumentType = " Capitalización";
        break;
      case "otherincome":
        formatDocumentType = " Otros Ingresos";
        break;



    }
  }
  if (documentType && documentType === DocumentDomain.MOVEMENT && documentOriginType) {
    switch (documentOriginType) {
      case "other":
        formatDocumentType = "Otro Movimiento";
        break;
    }
  }

  return formatDocumentType;
}

export function formatBank(bankid) {
  switch (bankid) {
    case "cl_banco_itau":
      return "Itaú";
    case "cl_banco_santander":
      return "Santander";
    case "cl_banco_bci":
      return "BCI";
    case "cl_banco_bice":
      return "BICE";
    case "cl_banco_bancoestado":
      return "Estado";
    case "cl_banco_bbva":
      return "BBVA";
    case "cl_banco_security":
      return "Security";
    case "cl_banco_de_chile":
      return "de Chile";
    case "cl_banco_falabella":
      return "Falabella";
    case "cl_banco_scotiabank":
      return "Scotiabank";
    case "cl_banco_corpbanc":
      return "Corpbanca";
    default:
  //    console.log("bankid: " + bankid);
//console.log("toString(bankid)?.toLowerCase(): " + bankid?.toLowerCase());
//console.log("(''+bankid)?.toLowerCase().replace('banco'): " + (''+bankid)?.toLowerCase().replace(/banco/g,''));
      return (''+bankid)?.toLowerCase().replace(/banco/g,'').toUpperCase();
  }

}

export function shortDescription(description) {
  if (description) {
    return description.substring(0, 50) + '...';
  }
  return '';
}

export function veryShortDescription(description) {
  if (description) {
    if (description.length < 14) {
      return description;
    }
    return description.substring(0, 14) + '...';
  }
  return '';
}

export function formatDocumentSenderOrReceiver(document, company) {
  if (document.document_type === DocumentDomain.INVOICE && formatRut(document.document_receiver_legal_id) === formatRut(company.company_legal_id)) {
    return 'Recibido';
  } else if (document.document_type === DocumentDomain.INVOICE && formatRut(document.document_sender_legal_id) === formatRut(company.company_legal_id)) {
    return 'Emitido';
  } else if (document.document_type === DocumentDomain.BILL && formatRut(document.document_sender_legal_id) === formatRut(company.company_legal_id)) {
    return 'Emitido';
  }
  else {
    return '';
  }
}


export function getMonthsToDisplay(monthOne, monthTwo, monthThree) {
  const today = new Date();
  const monthOneName = moment(new Date(today.getFullYear(), (parseInt(monthOne) - 1), 1)).format('MMM');
  const monthTwoName = moment(new Date(today.getFullYear(), (parseInt(monthTwo) - 1), 1)).format('MMM');
  const monthThreeName = moment(new Date(today.getFullYear(), (parseInt(monthThree) - 1), 1)).format('MMM');

  return [monthOneName, monthTwoName, monthThreeName];
}

